import React from 'react'
import { StyledSubscribe } from './styles/Subscribe.style'
import Green from '../../../../assets/images/green.png';
import Blue from '../../../../assets/images/blue.png';

import { GreenTick, PurpleTick, WineTick, GoldTick} from '../../../../assets/svgs/svg'
import Button, {SwitchBtn} from '../reusable_ui/button/Button'

const Subscribe = () => {
  
  
return (
<StyledSubscribe>

<div className='bg_img'>
   <img src={Green} className='green' alt='green' />
   <img src={Blue} className='blue' alt='blue' />
    </div>
<div className='subscribe__content'>
   <div className='subscribe__header'>
      <h2 className='subscribe__title'> Subscription</h2>
      <p>Choose the best Plan for your business</p>
  </div>

   <div className='subscribe__center'>
      <p>Month </p>
      <div>
         <SwitchBtn />
       </div>
      <p className='year'>Yearly</p>
   </div>

    
   <div className='subscribe__planFlex'>
      <div className='subscribe__plan'>

         <div className='subscribe__list'>
          <div className='subscribe__planGrid'>
             
            <div className='subscribe_payment'>
                  <div className='subscribe__desc'>
                     <p> Starter</p>
                     <main></main>
                  </div>
               
                <div className='price one'>
                      <strong> <sup>$</sup>0</strong> 
                      <p>/ Month</p>
                  </div>
                  <></>
            </div>
         
         <></>
         <div className='subscribe__planList'>
         {/* 1 */}
         <div className='subscribe__planItem'>
         <GreenTick />
         <p>Unlimited pages</p>
         </div>
         {/* 2 */}

         <div className='subscribe__planItem'>
         <GreenTick/>
         <p>Unlimited pages</p>
         </div> 
         {/* 3 */}

         <div className='subscribe__planItem'>
         <GreenTick/>
         <p>Unlimited pages</p>
         </div>
         {/* 4*/}

         <div className='subscribe__planItem'>
         <GreenTick/>
         <p>Email notifications</p>
         </div>
         {/* 5 */}

         <div className='subscribe__planItem'>
         <GreenTick/>
         <p>Weekly reports</p>
         </div>
         {/* 6*/}

         <div className='subscribe__planItem'>
         <GreenTick/>
         <p>Customisation options</p>
         </div>
         {/* 7 */}

         <div className='subscribe__planItem'>
         <GreenTick/>
         <p>No whitelabel branding</p>
         </div>
         </div>
         <></>

         <div className='subscribe__btn'>
         <Button color="#377DFF" bgColor='white'>Choose plan</Button> 
         </div>
         <></>
         </div>

         </div>
         {/* 2nd grid */}

         <div className='subscribe__list'>
         
         <div className='subscribe__planGrid'>
             
             <div className='subscribe_payment'>
                  <div className='subscribe__desc'>
                  <p className='type'> Business</p>
                  <main></main>
               </div>
               
                  <div className='price two'>
                     <strong> <sup>$</sup>50</strong> <p>/ Month</p>
                  </div>
                  <></>
            </div>
         
         <></>
         <div className='subscribe__planList'>
         {/* 1 */}
         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>Unlimited pages</p>
         </div>
         {/* 2 */}

         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>Unlimited pages</p>
         </div> 
         {/* 3 */}

         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>Unlimited pages</p>
         </div>
         {/* 4*/}

         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>Email notifications</p>
         </div>
         {/* 5 */}

         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>Weekly reports</p>
         </div>
         {/* 6*/}

         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>Customisation options</p>
         </div>
         {/* 7 */}

         <div className='subscribe__planItem'>
         <PurpleTick />
         <p>No whitelabel branding</p>
         </div>
         </div>
         <></>

         <div className='subscribe__btn'>
         <Button>Choose plan</Button> 
         </div>
         <></>
         </div>



         </div>

         {/* 3rd grid */}
            
         <div className='subscribe__list'>
         
         <div className='subscribe__planGrid'>
               <div className='subscribe_payment'>
                        <div className='subscribe__desc'>
                           <p> Professionals</p>
                           <main></main>
                       </div>
                     
                        <div className='price three'>
                           <strong> <sup>$</sup>100</strong> <p>/ Month</p>
                        </div>
                        <></>
                  </div>
               <></>
               <div className='subscribe__planList'>
               {/* 1 */}
               <div className='subscribe__planItem'>
                 <GoldTick />
                 <p>Unlimited pages</p>
               </div>
               {/* 2 */}

               <div className='subscribe__planItem'>
                <GoldTick />
               <p>Unlimited pages</p>
               </div> 
               {/* 3 */}

               <div className='subscribe__planItem'>
                <GoldTick />
               <p>Unlimited pages</p>
               </div>
               {/* 4*/}

               <div className='subscribe__planItem'>
                <GoldTick />
               <p>Email notifications</p>
               </div>
               {/* 5 */}

               <div className='subscribe__planItem'>
                <GoldTick />
               <p>Weekly reports</p>
               </div>
               {/* 6*/}

               <div className='subscribe__planItem'>
                <GoldTick />
               <p>Customisation options</p>
               </div>
               {/* 7 */}

               <div className='subscribe__planItem'>
                <GoldTick />
               <p>No whitelabel branding</p>
               </div>
               </div>
               <></>

               <div className='subscribe__btn'>
               <Button color="#377DFF" bgColor='white'>Choose plan</Button> 
               </div>
               <></>
            </div>

         </div>

      {/* 4th grid */}
      <div className='subscribe__list'>
         
         <div className='subscribe__planGrid'>
               <div className='subscribe_payment'>
                        <div className='subscribe__desc'>
                        <p> Premium</p>
                        <main></main>
                     </div>
                     
                        <div className='price four'>
                           <strong> <sup>$</sup>120</strong> <p>/ Month</p>
                        </div>
                        <></>
               </div>
            <></>
            
            <></>
            <div className='subscribe__planList'>
            {/* 1 */}
            <div className='subscribe__planItem'>
            <WineTick />
            <p>Unlimited pages</p>
            </div>
            {/* 2 */}

            <div className='subscribe__planItem'>
            <WineTick />
            <p>Unlimited pages</p>
            </div> 
            {/* 3 */}

            <div className='subscribe__planItem'>
            <WineTick />
            <p>Unlimited pages</p>
            </div>
            {/* 4*/}

            <div className='subscribe__planItem'>
            <WineTick />
            <p>Email notifications</p>
            </div>
            {/* 5 */}

            <div className='subscribe__planItem'>
            <WineTick />
            <p>Weekly reports</p>
            </div>
            {/* 6*/}

            <div className='subscribe__planItem'>
            <WineTick />
            <p>Customisation options</p>
            </div>
            {/* 7 */}

            <div className='subscribe__planItem'>
            <WineTick />
            <p>No whitelabel branding</p>
            </div>
            </div>
            <></>

            <div className='subscribe__btn'>
            <Button color="#377DFF" bgColor='white'>Choose plan</Button> 
            </div>
            <></>
         </div>

      </div>
      </div> {/* <> subscribe plan ends here</> */}
   </div> 
   
</div>
</StyledSubscribe>
)
}

export default Subscribe